import type { FdeCopy, ProjectTask } from '@/frontend/features/Fde/types'

export default function ProjectTaskMetadata({ task, copy }: { task: ProjectTask; copy: FdeCopy }) {
  const format = (value: string) =>
    new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(value))

  return (
    <div className="mb-6 mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground">
      <span className="inline-flex items-center gap-1.5" title={copy.management.task_created_at.replace('%{date}', format(task.created_at))}>
        {task.creator_avatar_url && <img src={task.creator_avatar_url} alt="" className="size-5 shrink-0 rounded-full object-cover" />}
        {copy.management.task_created_by.replace('%{name}', task.created_by_label)}
      </span>
      <span aria-hidden="true">·</span>
      <time dateTime={task.updated_at}>
        {copy.management.task_last_saved.replace('%{date}', format(task.updated_at))}
      </time>
    </div>
  )
}
